import React from 'react';
import c from 'classnames';
import ModalLayout, { ModalLayoutProps } from '../../../Modal/ModalLayout';
import ModalFooter from '../../../Modal/ModalFooter';
import s from './HorizontalLayout.scss';

interface Props
  extends Omit<ModalLayoutProps, 'footer' | 'content' | 'header'> {
  title: React.ReactNode;
  message: React.ReactNode;
  image?: React.ReactNode;

  footerRight: React.ReactNode[];
  footerLeft: React.ReactNode[];

  className?: string;
}

const HorizontalLayout: React.FC<Props> = ({
  title,
  message,
  image,
  className,
  footerLeft,
  footerRight,
  ...rest
}) => (
  <ModalLayout
    className={c(s['root'], className)}
    footer={<ModalFooter left={footerLeft} right={footerRight} />}
    content={
      <div className={s['content-root']}>
        {image && <div className={s['image']}>{image}</div>}
        <div className={s['title']}>{title}</div>
        <div className={s['message']}>{message}</div>
      </div>
    }
    {...rest}
  />
);
HorizontalLayout.displayName = 'HorizontalLayout';

export default HorizontalLayout;
